import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import WaveUIForm_V2 from '@/shared/components/forms/WaveUIForm_V2';
import FieldType from '@/shared/components/forms/WaveUIForm_V2/types/fieldType.enum';
import WaveUIAccordion from '@/shared/components/widgets/WaveUIAccordion';

type AccountDetailsFormProps = {
  accountDetailsFormFields: Record<string, string>;
  accountDetailsFormErrors: Record<string, string>;
  onUpdateAccountDetails: (values: Record<string, unknown>) => void;
};

const AccountDetailsForm: FC<AccountDetailsFormProps> = ({
  accountDetailsFormFields,
  accountDetailsFormErrors,
  onUpdateAccountDetails,
}) => {
  const { t } = useTranslation(['customers', 'forms']);

  return (
    <WaveUIAccordion title={t('customers:accountDetails')} defaultExpanded>
      <WaveUIForm_V2
        fields={[
          {
            columns: 6,
            field_type: FieldType.Text,
            field_props: {
              name: 'first_name',
              label: t('forms:first_name'),
              placeholder: t('forms:first_name_placeholder'),
              value: accountDetailsFormFields.first_name,
              required: true,
              error: !!accountDetailsFormErrors.first_name,
              helperText: accountDetailsFormErrors.first_name,
            },
          },
          {
            columns: 6,
            field_type: FieldType.Text,
            field_props: {
              name: 'last_name',
              label: t('forms:last_name'),
              placeholder: t('forms:last_name_placeholder'),
              value: accountDetailsFormFields.last_name,
              required: true,
              error: !!accountDetailsFormErrors.last_name,
              helperText: accountDetailsFormErrors.last_name,
            },
          },
          {
            field_type: FieldType.Text,
            field_props: {
              name: 'email_address',
              label: t('forms:email_address'),
              placeholder: t('forms:email_address_placeholder'),
              value: accountDetailsFormFields.email_address,
              required: true,
              error: !!accountDetailsFormErrors.email_address,
              helperText: accountDetailsFormErrors.email_address,
            },
          },
          {
            field_type: FieldType.Text,
            field_props: {
              name: 'phone_number',
              label: t('forms:phone_number'),
              placeholder: t('forms:phone_number_placeholder'),
              value: accountDetailsFormFields.phone_number,
              required: true,
              error: !!accountDetailsFormErrors.phone_number,
              helperText: accountDetailsFormErrors.phone_number,
            },
          },
        ]}
        getFieldsValues={onUpdateAccountDetails}
      />
    </WaveUIAccordion>
  );
};

export default AccountDetailsForm;
